/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { lazy, Suspense } from 'react';

import './contained-button.css';

const LoadingSpinner = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: 'loading-spinner' */ 'components/UI/LoadingSpinner')
);

const ContainedButton = ({
  className,
  type,
  loading,
  disabled,
  ...rest
}) => (
  <button
    {...rest}
    disabled={disabled || loading}
    className={`contained-button ${className}`}
    type={type || 'button'}>
    Analyze
    {loading && (
      <>
        <>&nbsp;</>
        <Suspense fallback=''>
          <LoadingSpinner
            width={2}
            height={2}
            borderWidth={.3}
            margin={0} />
        </Suspense>
      </>
    )}
  </button>
);

export default ContainedButton;
